<template>
  <form @submit.prevent="submitForm">
    <div class="update-close">
      <p @click.prevent="$emit('close')">
        ANNULLER <font-awesome-icon icon="times" />
      </p>
    </div>

    <BaseInput
      label="ID / navn"
      v-model="formTemp.name"
    />

    <BaseFormField label="Publiceringsdato">
      <Datejump v-model="publishDate">
        <BaseDatetimePicker v-model="publishDate" />
      </Datejump>
    </BaseFormField>

    <BaseFormField label="Ikon">
      <IconPicker
        v-model="formTemp.iconID"
        @change="updateIcon"
      />
    </BaseFormField>

    <BaseInput
      label="Overskrift"
      v-model="formTemp.headline"
      title="Vælg dato"
    />

    <BaseTextarea
      label="Beskrivelse"
      v-model="formTemp.description"
    />

    <BaseFormField label="Status">
      <BaseCheckbox
        label="Slettet"
        v-model="formTemp.deleted"
      />
    </BaseFormField>

    <BaseCheckbox
      label="Udsend notifikation"
      v-model="formTemp.sendNotification"
    />

    <LocalLinks :form="formTemp" />

    <BaseButton
      full
      label="Gem note"
      :disabled="loading"
    />
    <BaseSpinner
      height="40px"
      width="40px"
      v-if="loading"
    />
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import LocalLinks from '../../LocalLinks.vue';
import BaseDatetimePicker from '../../BaseDatetimePicker.vue';
import BaseCheckbox from '../../BaseCheckbox.vue';
import Datejump from '../../Datejump.vue';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseButton from '../../BaseButton.vue';
import BaseTextarea from '../../BaseTextarea.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseInput from '../../BaseInput.vue';
import IconPicker from '../../IconPicker.vue';
import GlobalNotesService from '../../../services/GlobalNotesService';
import DateFormat from '../../../filters/DefaultDate';


export default {
    name: 'UpdateGlobalNotesForm',
    components: {
        IconPicker, BaseInput, BaseFormField, BaseCheckbox, BaseTextarea, BaseButton, BaseSpinner, Datejump, BaseDatetimePicker, LocalLinks,
    },
    props: {
        form: { type: Object, required: true },
        action: {
            type: String,
            required: true,
            validator(value) {
                return ['update', 'newVersion'].indexOf(value) !== -1;
            },
        },
    },
    data() {
        return {
            loading: false,
            formTemp: {},
        };
    },
    computed: {
        publishDate: {
            get() {
                return this.formTemp.publishDate;
            },
            set(newValue) {
                this.formTemp.publishDate = newValue;
            },
        },
        formattedIconID() {
            return this.formTemp.iconID === -1 ? null : this.formTemp.iconID;
        },
    },
    validations: {
        form: {
            name: { required },
            description: { required },
            headline: { required },
            iconID: { required },
        },
    },
    methods: {
        updateIcon(icon) {
            this.formTemp.iconID = icon.id;
        },
        async submitForm() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                this.$snotify.error('Ikke alle felter er udfyldt korrekt.');
                return;
            }

            try {
                this.loading = true;
                let action = 'update';

                if (this.action === 'newVersion') {
                    action = 'newVersion';
                }

                const format = { ...this.formTemp, iconID: this.formattedIconID, publishDate: DateFormat(this.formTemp.publishDate) };
                if (action === 'newVersion') {
                    delete format.versionNumber;
                }
                const payload = await GlobalNotesService[action](format);

                this.$snotify.success(`${payload.name} er gemt`);
                this.loading = false;
                this.$emit('saved', { payload, action: this.action });
            } catch (error) {
                this.loading = false;
            }
        },
    },
    created() {
        this.formTemp = { ...this.form };

        if (this.action === 'newVersion') {
            this.formTemp.publishDate = window.moment().add(1, 'day').startOf('day').format();
            this.formTemp.sendNotification = true;
        }
    },
};
</script>

<style lang="scss" scoped>
.update-close {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    user-select: none;
}
</style>
